// extracted by mini-css-extract-plugin
export var closeButton = "_39-3";
export var header = "_39-0";
export var link = "_39-1";
export var retryButton = "_39-2";